var _style, _linearGradient, _linearGradient2, _linearGradient3, _defs, _mask, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 965,
    height: 265,
    viewBox: "0 0 965 265",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st4{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st5{mask:url(#SVGID_4_);fill:url(#SVGID_5_);}\n\t.st6{opacity:0.6;fill:url(#SVGID_6_);}\n\t.st7{fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);}\n\t.st10{fill:url(#SVGID_10_);}\n\t.st11{fill:url(#SVGID_11_);}\n\t.st12{fill:url(#XMLID_8_);}\n\t.st13{fill:url(#SVGID_12_);}\n\t.st14{fill:url(#SVGID_13_);}\n\t.st15{fill:url(#SVGID_14_);}\n\t.st16{fill:url(#SVGID_15_);}\n\t.st17{fill:url(#SVGID_16_);}\n\t.st18{fill:url(#SVGID_17_);}\n\t.st19{fill:url(#SVGID_18_);}\n\t.st20{fill:url(#SVGID_19_);}\n\t.st21{fill:url(#SVGID_20_);}\n\t.st22{fill:url(#SVGID_21_);}\n\t.st23{fill:url(#SVGID_22_);}\n\t.st24{fill:url(#SVGID_23_);}\n\t.st25{fill:url(#SVGID_24_);}\n\t.st26{fill:url(#SVGID_25_);}\n\t.st27{fill:url(#SVGID_26_);}\n\t.st28{fill:url(#SVGID_27_);}\n")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 802.32,
    x2: 859.04,
    y1: -6.5905,
    y2: 110.18,
    gradientTransform: "matrix(0 1.0604 -1.02 0 467.01 -835.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 967.28,
    x2: 856.11,
    y1: 287.35,
    y2: 165.13,
    gradientTransform: "matrix(0 1.0604 1.02 0 175.88 -835.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    x1: 400.57,
    x2: 528.12,
    y1: 497.3,
    y2: 497.3,
    gradientTransform: "matrix(-1.02 0 0 1.0604 872.23 -414.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    x: 412.2,
    y: 435.9,
    width: 26.6,
    height: 42.4,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    x: 412.2,
    y: 435.9,
    width: 26.6,
    height: 42.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    x: 412.2,
    y: 435.9,
    width: 26.6,
    height: 42.4,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "SVGID_4_",
    x: 412.2,
    y: 435.9,
    width: 26.6,
    height: 42.4,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    x1: 913.26,
    x2: 842.45,
    y1: 119.28,
    y2: 98.641,
    gradientTransform: "rotate(90 463.08 65.791)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    offset: 0.084861
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ddd",
    offset: 0.2252
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4",
    offset: 0.4037
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7B7B",
    offset: 0.6134
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333",
    offset: 0.8464
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m437.3 474.6c0.1-0.9 0.4-2.2 1.5-3.1-15-9.5-26.5-25.5-20.7-35.6-0.4 0.2-0.7 0.4-1.1 0.7-13.1 10.2 2.8 31.8 21.8 41.7-1.3-1.1-1.5-2.6-1.5-3.7z",
    mask: "url(#SVGID_4_)"
  })))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    x1: 913.26,
    x2: 842.45,
    y1: 119.28,
    y2: 98.641,
    gradientTransform: "matrix(0 1.0604 -1.02 0 467.01 -835.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    offset: 1
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    x1: 403.27,
    x2: 524.39,
    y1: 588.03,
    y2: 588.03,
    gradientTransform: "matrix(-1.02 0 0 1.0604 872.23 -414.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    x1: 71.119,
    x2: 229.21,
    y1: 507.24,
    y2: 507.24,
    gradientTransform: "matrix(1.02 0 0 1.0604 -72.418 -414.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094D7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098DD",
    offset: 0.2989
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5E0",
    offset: 1
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    x1: 240.38,
    x2: 379,
    y1: 507.1,
    y2: 507.1,
    gradientTransform: "matrix(1.02 0 0 1.0604 -72.418 -414.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094D7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098DD",
    offset: 0.2989
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5E0",
    offset: 1
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    x1: 560.28,
    x2: 837.23,
    y1: 507.1,
    y2: 507.1,
    gradientTransform: "matrix(1.02 0 0 1.0604 -72.418 -414.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094D7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098DD",
    offset: 0.2989
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5E0",
    offset: 1
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    x1: 850.4,
    x2: 1008.5,
    y1: 507.1,
    y2: 507.1,
    gradientTransform: "matrix(1.02 0 0 1.0604 -72.418 -414.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094D7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098DD",
    offset: 0.2989
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5E0",
    offset: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.98958 0 0 .96154 7.5 7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.04
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m375.15 92.993c-19.38-10.604-35.597-33.507-22.235-44.217 1.428-0.95432 2.8559-1.8026 4.3859-2.6509 0.408-0.21206 0.91797-0.42413 1.326-0.63622l56.303-24.706-8.4658-20.783 70.276 17.178-36.821 64.47-8.4658-20.783-55.589 24.282c-1.734 1.0604-2.1419 2.6509-2.2439 3.9233 0 1.0604 0.20398 2.6509 1.53 3.9233z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m451.75 208.57c11.526-7.8467 18.87-20.677 19.686-35.204 1.02-16.33-6.1198-31.493-19.176-40.718-0.61197-0.42414-1.224-0.84828-1.938-1.1664l-12.648-6.8923-26.417-14.421-42.431-23.116-9.1798 4.9837c-6.5278 3.4992-10.506 10.498-10.506 18.132 0 7.6346 4.0799 14.633 10.506 18.132l70.99 38.703c18.258 9.8613 33.455 31.387 21.113 41.566z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m442.67 177.72-45.083-24.6-28.151-15.375-13.464-7.3165c-0.71398-0.42414-1.428-0.84829-2.04-1.2724-12.954-9.1191-20.4-23.964-20.4-39.976 0-1.0604 0-2.1207 0.10201-3.2871 1.02-15.481 8.7718-29.266 21.113-37.537-13.362 10.816 2.8559 33.719 22.235 44.217l75.478 41.142c6.9358 3.8173 11.22 11.24 11.22 19.299 0 8.0587-4.2839 15.481-11.22 19.299z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m373.62 88.964c0.102-0.95433 0.40799-2.3328 1.53-3.2871-15.3-10.073-27.029-27.039-21.113-37.749-0.40799 0.21207-0.71399 0.42414-1.122 0.74225-13.362 10.816 2.8559 33.719 22.235 44.217-1.326-1.1664-1.53-2.7569-1.53-3.9233z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m403.4 253-7.9558-19.511 52.937-23.222c0.40798-0.21207 0.81598-0.42413 1.224-0.63621 1.428-0.74224 2.8559-1.5905 4.1819-2.5449 2.5499-1.5905 0 0 0 0 2.244-1.5905 4.7939-3.7112 5.8139-5.7259 6.0178-12.194-11.628-27.569-26.825-35.84 1.224 1.1664 1.428 2.6509 1.428 3.7112-0.10199 1.1664-0.50997 2.6509-2.0399 3.6052l-52.223 22.904-7.9558-19.511-34.679 60.653z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m161.36 18.768v62.879c0 11.558-2.142 22.374-6.3238 32.659-4.1819 10.179-9.8937 19.086-17.238 26.721-7.3438 7.6346-15.912 13.573-25.703 17.92-9.7918 4.3475-20.297 6.5742-31.415 6.5742s-21.521-2.1207-31.415-6.5742c-9.7918-4.3475-18.36-10.285-25.703-17.92-7.3438-7.6346-13.056-16.542-17.238-26.721-4.1819-10.179-6.3238-21.101-6.3238-32.659v-62.879h2.0399c5.3039 0 10.2 1.0604 14.892 3.075 4.6919 2.0147 8.6698 4.8776 12.138 8.4829 3.3659 3.6052 6.1199 7.8467 8.1598 12.724 2.04 4.8777 3.0599 10.073 3.0599 15.481v23.116c0 5.832 1.02 11.346 3.2639 16.436 2.1419 5.0897 4.9979 9.4372 8.5678 13.254 3.5699 3.7113 7.8538 6.7863 12.75 8.907 4.8959 2.2268 10.098 3.3932 15.81 3.3932 5.4059 0 10.71-1.0604 15.606-3.3932 4.9979-2.2268 9.2818-5.1958 12.852-8.907 3.5699-3.7113 6.4258-8.1648 8.5678-13.254 2.1419-5.0897 3.2639-10.498 3.2639-16.436v-23.116c0-5.5139 1.02-10.604 3.0599-15.481 2.04-4.8776 4.7939-9.1191 8.3638-12.724 3.4679-3.6052 7.5478-6.4682 12.24-8.4829 4.6919-2.0147 9.6898-3.075 14.892-3.075zm-60.484 148.56v29.796c0 4.2414-0.81598 8.2708-2.3459 12.194-1.53 3.8173-3.6719 7.2104-6.4258 10.073-2.7539 2.863-5.9159 5.0897-9.6898 6.6803-3.6719 1.5905-7.5478 2.4388-11.73 2.4388h-10.2v-61.077c13.566 3.2871 27.029 3.2871 40.391-0.10603z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m314.15 18.45v2.1207c0 5.5139-1.02 10.604-3.0599 15.481-2.04 4.8777-4.7939 9.1191-8.3638 12.724-3.4679 3.6052-7.5478 6.4682-12.24 8.4829-4.6919 2.0147-9.6898 3.075-14.892 3.075h-62.524v40.082h-2.04c-8.1598 0-15.708 2.2268-22.643 6.7863-6.9358 4.5595-12.138 10.71-15.606 18.344v-67.439c0-5.5139 1.02-10.604 3.0599-15.481 2.04-4.8776 4.7939-9.0131 8.1598-12.618 3.3659-3.4992 7.4458-6.3622 12.138-8.4829 4.6919-2.1207 9.6898-3.1811 14.892-3.1811h103.12zm0 167.96v2.1207c0 5.5138-1.02 10.604-3.0599 15.481-2.04 4.8777-4.7939 9.013-8.3638 12.618-3.4679 3.4992-7.5478 6.3622-12.24 8.4829s-9.6898 3.1811-14.892 3.1811h-72.418c-4.0799 0-7.9558-0.84828-11.73-2.4388-3.6719-1.5906-6.9358-3.9233-9.7918-6.7863-2.8559-2.969-4.9979-6.3622-6.5278-10.179-1.53-3.8173-2.3459-7.8467-2.3459-12.194v-52.17c0-5.5139 1.02-10.604 3.0599-15.481 2.04-4.8777 4.7939-9.013 8.1598-12.618 3.3659-3.4992 7.4458-6.3622 12.138-8.4829 4.6919-2.1207 9.6898-3.1811 14.892-3.1811h82.924v2.1207c0 5.5139-1.02 10.604-3.0599 15.481-2.04 4.8777-4.7939 9.013-8.3638 12.618-3.4679 3.4992-7.5478 6.3622-12.24 8.4829s-9.6898 3.1811-14.892 3.1811h-42.329v39.763z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m617.39 159.69c2.9579 16.223 9.6898 30.644 20.196 43.475-7.5478 8.0587-16.32 14.315-26.315 18.662-9.8938 4.3475-20.399 6.5742-31.211 6.5742-11.118 0-21.521-2.1207-31.415-6.5742-9.7918-4.3475-18.36-10.285-25.703-17.92-7.3438-7.6346-13.056-16.542-17.34-26.721-4.2839-10.179-6.4258-21.101-6.4258-32.659v-126.08h2.04c5.2018 0 10.098 1.0604 14.79 3.1811 4.5899 2.1207 8.6698 4.9837 12.138 8.6949 3.4679 3.6052 6.2218 7.8467 8.2618 12.724 2.0399 4.8777 3.0599 10.073 3.0599 15.481v85.995c0 5.832 1.02 11.346 3.0599 16.436 2.04 5.0897 4.8959 9.4372 8.6698 13.254 3.6719 3.7113 8.0578 6.6803 12.954 8.907 4.8959 2.2267 10.2 3.3931 15.81 3.3931 8.3638 0 16.014-2.4388 22.847-7.3165 6.7318-4.8776 11.628-11.346 14.586-19.511zm2.8559-101.16c0-5.5139 1.02-10.604 3.0599-15.481 2.04-4.8776 4.7939-9.1191 8.1598-12.724s7.4458-6.5742 12.138-8.6949c4.6919-2.1207 9.6898-3.1811 14.892-3.1811h2.04v126.08c0 5.832 1.02 11.346 3.2639 16.436 2.1419 5.0897 4.9979 9.4372 8.5678 13.254 3.5699 3.7113 7.8538 6.6803 12.75 8.907 4.8959 2.2267 10.098 3.3931 15.81 3.3931 5.4058 0 10.71-1.0604 15.606-3.3931 4.9979-2.2268 9.2818-5.1958 12.852-8.907 3.5699-3.7113 6.4258-8.1648 8.5678-13.254 2.1419-5.0897 3.2639-10.498 3.2639-16.436v-85.995c0-5.5139 1.02-10.604 3.0599-15.481 2.04-4.8776 4.7939-9.1191 8.1598-12.724 3.3659-3.6052 7.4458-6.5742 12.138-8.6949 4.6919-2.1207 9.6898-3.1811 14.892-3.1811h2.04v126.08c0 11.558-2.142 22.374-6.3238 32.659-4.1819 10.179-9.8938 19.086-17.238 26.721-7.3438 7.6346-15.912 13.573-25.703 17.92-9.7918 4.3475-20.298 6.5742-31.415 6.5742s-21.521-2.1207-31.415-6.5742c-9.7918-4.3475-18.36-10.285-25.703-17.92-7.3438-7.6346-13.056-16.542-17.238-26.721-4.1819-10.179-6.3238-21.101-6.3238-32.659v-85.995z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m956.23 102.64v125.65h-1.734c-5.3039 0-10.2-1.0604-14.892-3.1811-4.692-2.1207-8.7717-4.9837-12.24-8.4829-3.4679-3.4992-6.3238-7.7406-8.3638-12.618-2.04-4.8776-3.0599-10.073-3.0599-15.481v-19.405h-82.72c-5.3039 0-10.2-1.0604-14.892-3.1811-4.6919-2.1207-8.6698-4.9837-12.138-8.4829-3.3659-3.4992-6.1198-7.7406-8.1598-12.618-2.04-4.8776-3.0599-10.073-3.0599-15.481v-26.721c0-11.558 2.04-22.374 6.3238-32.659 4.1819-10.179 9.8938-19.086 17.238-26.721 7.3438-7.6346 15.912-13.573 25.703-18.026s20.298-6.6803 31.415-6.6803c11.118 0 21.521 2.2268 31.415 6.6803 9.7918 4.4535 18.36 10.498 25.703 18.026 7.3438 7.6346 13.056 16.542 17.238 26.721 4.0798 10.179 6.2218 21.101 6.2218 32.659zm-120.97 85.889c0 5.5138-1.02 10.604-3.0599 15.481-2.0399 4.8777-4.7939 9.013-8.1598 12.618-3.3659 3.4992-7.4458 6.3622-12.138 8.4829s-9.6898 3.1811-14.892 3.1811h-2.04v-80.481c3.4679 7.7406 8.6698 13.891 15.606 18.556 6.9358 4.6656 14.484 6.9984 22.643 6.9984h2.0399zm80.68-61.289v-24.706c0-5.938-1.122-11.346-3.2639-16.436-2.142-5.0897-4.9979-9.5432-8.5678-13.467-3.5699-3.8173-7.8538-6.8923-12.852-9.013-4.9979-2.1207-10.2-3.1811-15.606-3.1811-5.6099 0-10.914 1.0604-15.81 3.1811-4.8959 2.1207-9.0778 5.0897-12.75 9.013-3.5699 3.8173-6.4258 8.3768-8.5678 13.467-2.1419 5.0897-3.2639 10.604-3.2639 16.436v24.706z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    transform: "matrix(1.02 0 0 1.0604 -72.418 -414.28)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_8_",
    x1: 215.03,
    x2: 37.53,
    y1: 511.89,
    y2: 318.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st12",
    d: "m131.7 440.8-12.7-10.2 18.4-12 12.9 10.7-18.6 11.5 18.5 11.4-12.9 10.8-18.3-12zm18.5 11.4 12.9 10.7 18.4-12-12.7-10.2zm31.3-21.6-18.4-12-12.9 10.7 18.5 11.4zm-31.3 23.9-12.9 10.7-5.5-3.6v4l18.4 11 18.4-11v-4l-5.5 3.6z",
    fill: "url(#XMLID_8_)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02 0 0 1.0604 -72.418 -414.28)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    x1: 676.89,
    x2: 1057.2,
    y1: 612.55,
    y2: 681.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m756.4 618.9h2.4v14.8h9.1v2.1h-11.5z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    x1: 677.4,
    x2: 1057.7,
    y1: 609.79,
    y2: 679.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m781.5 631.5h-9l-1.9 4.2h-2.5l7.6-16.9h2.4l7.7 16.9h-2.5zm-0.8-1.9-3.6-8.3-3.6 8.3z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    x1: 678.05,
    x2: 1058.3,
    y1: 606.21,
    y2: 675.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m789.7 635.3c-1.2-0.4-2.1-0.9-2.8-1.5l0.9-1.9c0.6 0.6 1.5 1 2.5 1.4s2 0.5 3.1 0.5c1.4 0 2.4-0.2 3.1-0.7s1-1.1 1-1.9c0-0.6-0.2-1-0.6-1.4s-0.8-0.6-1.4-0.8-1.3-0.4-2.3-0.7c-1.3-0.3-2.3-0.6-3.1-0.9s-1.4-0.8-2-1.4-0.8-1.5-0.8-2.6c0-0.9 0.2-1.7 0.7-2.4s1.2-1.3 2.2-1.7 2.2-0.7 3.6-0.7c1 0 2 0.1 2.9 0.4 1 0.3 1.8 0.6 2.5 1.1l-0.8 1.9c-0.7-0.4-1.5-0.8-2.3-1s-1.6-0.3-2.4-0.3c-1.4 0-2.4 0.2-3.1 0.7s-1 1.1-1 1.9c0 0.6 0.2 1 0.6 1.4s0.9 0.6 1.4 0.8c0.6 0.2 1.3 0.4 2.3 0.6 1.3 0.3 2.3 0.6 3.1 0.9s1.4 0.8 2 1.4 0.8 1.5 0.8 2.5c0 0.9-0.2 1.7-0.7 2.4s-1.2 1.3-2.2 1.7-2.2 0.6-3.6 0.6c-1.2 0.3-2.5 0.1-3.6-0.3z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    x1: 678.6,
    x2: 1058.9,
    y1: 603.2,
    y2: 672.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m806.5 621h-5.8v-2.1h13.9v2.1h-5.8v14.8h-2.4v-14.8z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    x1: 679.31,
    x2: 1059.6,
    y1: 599.29,
    y2: 668.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "m839.4 635.7v-12.3l-6.1 10.2h-1.1l-6.1-10.2v12.2h-2.3v-16.9h2l7 11.9 6.9-11.9h2v16.9h-2.3z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    x1: 679.81,
    x2: 1060.1,
    y1: 596.59,
    y2: 666.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m846.8 618.9h2.4v16.9h-2.4z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    x1: 680.05,
    x2: 1060.3,
    y1: 595.27,
    y2: 664.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m854.2 618.9h2.4v14.8h9.1v2.1h-11.5z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    x1: 680.66,
    x2: 1060.9,
    y1: 591.91,
    y2: 661.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "m880.8 633.6v2.1h-12.2v-16.9h11.9v2.1h-9.5v5.2h8.5v2h-8.5v5.4h9.8z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    x1: 681.33,
    x2: 1061.6,
    y1: 588.24,
    y2: 657.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "m891.2 618.9h7.1c1.8 0 3.4 0.4 4.7 1.1 1.4 0.7 2.5 1.7 3.2 3 0.8 1.3 1.1 2.7 1.1 4.4s-0.4 3.1-1.1 4.4c-0.8 1.3-1.8 2.3-3.2 3s-3 1.1-4.7 1.1h-7.1zm6.9 14.7c1.4 0 2.6-0.3 3.6-0.8s1.8-1.3 2.4-2.2c0.6-1 0.8-2.1 0.8-3.3 0-1.3-0.3-2.4-0.8-3.3-0.6-1-1.4-1.7-2.4-2.2s-2.2-0.8-3.6-0.8h-4.6v12.7h4.6z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    x1: 682.03,
    x2: 1062.3,
    y1: 584.4,
    y2: 653.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "m923.3 633.6v2.1h-12.2v-16.9h11.9v2.1h-9.5v5.2h8.5v2h-8.5v5.4h9.8z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    x1: 682.4,
    x2: 1062.7,
    y1: 582.39,
    y2: 651.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "m927.2 618.9h2.4v14.8h9.1v2.1h-11.5z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    x1: 682.86,
    x2: 1063.1,
    y1: 579.86,
    y2: 649.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "m941.5 618.9h2.4v16.9h-2.4z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    x1: 683.37,
    x2: 1063.6,
    y1: 577.06,
    y2: 646.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "m963.4 618.9-7.4 16.9h-2.4l-7.4-16.9h2.6l6.1 13.8 6.1-13.8z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    x1: 683.79,
    x2: 1064.1,
    y1: 574.77,
    y2: 644.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "m977.8 633.6v2.1h-12.2v-16.9h11.9v2.1h-9.5v5.2h8.5v2h-8.5v5.4h9.8z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    x1: 684.24,
    x2: 1064.5,
    y1: 572.29,
    y2: 641.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "m993 635.7-3.6-5.2h-1.1-4.2v5.1h-2.4v-16.9h6.6c2.2 0 3.9 0.5 5.2 1.6 1.3 1 1.9 2.5 1.9 4.3 0 1.3-0.3 2.4-1 3.3-0.6 0.9-1.6 1.6-2.7 2l4 5.7h-2.7zm-1.3-8.1c0.8-0.7 1.2-1.6 1.2-2.8s-0.4-2.2-1.2-2.8c-0.8-0.7-2-1-3.5-1h-4.1v7.6h4.1c1.6-0.1 2.7-0.4 3.5-1z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    x1: 684.95,
    x2: 1065.2,
    y1: 568.39,
    y2: 637.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6883A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37027",
    offset: 0.5653
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68C42",
    offset: 0.9557
  })), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "m1005.5 629.9v5.8h-2.4v-5.9l-6.7-11h2.6l5.4 8.9 5.4-8.9h2.4z",
    fill: "url(#SVGID_27_)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3caaedfbfc1d6e3f3aa499cd509df72f.svg";
export { ForwardRef as ReactComponent };